import { createSlice } from "@reduxjs/toolkit"
import {
  addCountry,
  deleteCountry,
  getAllCountries,
  getAllCountryList,
  getCountryDetails,
  getCountryList,
  updateCountry,
  updateCountryStatus,
} from "store/actions/countriesAction"
import {
  addFaq,
  deleteFaq,
  getAllFaq,
  getFaqDetails,
  getPageContentByType,
  updateFaq,
  updateFaqStatus,
  updatePageContentByType,
} from "store/actions/faqAction"
import { updateQuestion } from "store/actions/ratingsAction"

const initialState = {
  loading: true,
  isLoading: false,
  itemsPerPage: 10,
  totalPages: null,
  currentPage: 1,
  faqs: [],
  faqDetails: {},
  pageContent: {}, // T&C/PP
}

const usersSlice = createSlice({
  name: "faq",
  initialState,
  reducers: {},
  extraReducers: builder => {
    // GET ALL COUNTRIES
    builder
      .addCase(getAllFaq.pending, state => {
        state.loading = true
      })
      .addCase(getAllFaq.fulfilled, (state, action) => {
        state.loading = false
        const { status, data } = action.payload
        if (status) {
          const { totalCount, totalPages, currentPage } = action.payload
          state.faqs = data
          state.totalCount = totalCount
          state.totalPages = totalPages
          state.currentPage = currentPage
        }
      })
      .addCase(getAllFaq.rejected, (state, action) => {
        state.loading = false
      })

    // UPDATE  FAQ STATUS
    builder
      .addCase(updateFaqStatus.pending, state => {
        state.isLoading = true
      })
      .addCase(updateFaqStatus.fulfilled, (state, action) => {
        state.isLoading = false
        const { status } = action.payload
        if (status) {
          const { id, status } = action.meta.arg
          state.faqs = state.faqs.map(item =>
            item._id === id ? { ...item, status: Number(status) } : item
          )
        }
      })
      .addCase(updateFaqStatus.rejected, (state, action) => {
        state.isLoading = false
      })

    // ADD FAQ
    builder
      .addCase(addFaq.pending, state => {
        state.isLoading = true
      })
      .addCase(addFaq.fulfilled, (state, action) => {
        state.isLoading = false
      })
      .addCase(addFaq.rejected, (state, action) => {
        state.isLoading = false
      })

    // GET FAQ DETAILS
    builder
      .addCase(getFaqDetails.pending, state => {
        state.loading = true
        state.faqDetails = {}
      })
      .addCase(getFaqDetails.fulfilled, (state, action) => {
        state.loading = false
        const { status, data } = action.payload
        if (status) {
          state.faqDetails = data
        }
      })
      .addCase(getFaqDetails.rejected, (state, action) => {
        state.loading = false
      })

    //  UPDATE FAQ
    builder
      .addCase(updateFaq.pending, state => {
        state.isLoading = true
      })
      .addCase(updateFaq.fulfilled, (state, action) => {
        state.isLoading = false
      })
      .addCase(updateFaq.rejected, (state, action) => {
        state.isLoading = false
      })

    // DELETE FAQ
    builder
      .addCase(deleteFaq.pending, state => {
        state.isLoading = true
      })
      .addCase(deleteFaq.fulfilled, (state, action) => {
        const { status } = action.payload
        const { id } = action.meta.arg
        state.isLoading = false
        if (status) {
          state.faqs = state.faqs.filter(item => item._id !== id)
          if (state.totalCount !== null) {
            state.totalCount -= 1
          }
        }
      })
      .addCase(deleteFaq.rejected, (state, action) => {
        state.isLoading = false
      })

    //  UPDATE FAQ
    builder
      .addCase(updateQuestion.pending, state => {
        state.isLoading = true
      })
      .addCase(updateQuestion.fulfilled, (state, action) => {
        state.isLoading = false
      })
      .addCase(updateQuestion.rejected, (state, action) => {
        state.isLoading = false
      })

    // GET CONTENT TYPE (T&C/PP)
    builder
      .addCase(getPageContentByType.pending, state => {
        state.loading = true
      })
      .addCase(getPageContentByType.fulfilled, (state, action) => {
        state.loading = false
        state.pageContent = {}
        const { statusCode, status, data } = action.payload || {}
        if (statusCode === 200 && status) {
          state.pageContent = data
        }
      })
      .addCase(getPageContentByType.rejected, (state, action) => {
        state.loading = false
      })

    builder
      .addCase(updatePageContentByType.pending, state => {
        state.isLoading = true
      })
      .addCase(updatePageContentByType.fulfilled, (state, action) => {
        state.isLoading = false
      })
      .addCase(updatePageContentByType.rejected, (state, action) => {
        state.isLoading = false
      })
  },
})

export default usersSlice.reducer
